import { AppView } from '../constants';
import { useSetPageName } from './flowManager';
import {
  ConfirmOptions,
  useConfirm as useMuiConfirm,
} from 'material-ui-confirm';

export const useConfirm = (pageName: AppView) => {
  const setPageName = useSetPageName();
  const muiConfirm = useMuiConfirm();

  return async (options?: ConfirmOptions | undefined) => {
    setPageName(pageName);
    await muiConfirm(options);
  };
};
